import {Form, TabContent, TabPane} from "reactstrap";
import React from "react";
import {PrimaryDetails} from "./primaryDetails";
import {BrandDetails} from "./brandDetails";
import {SellerStoreDescription} from "./sellerStoreDescription";
import {ExtraInformation} from "./extraInformation";
import {HeadingLinks} from "./headingLinks";
import {CustomerServiceContactDetails} from "./customerServiceContactDetails";
import {ReturnsWarehouseAddress} from "./returnsWarehouseAddress";
import {UploadImage} from "./uploadImage";
import {UploadBannerImage} from "./uploadBannerImage";
import {SellerShopifyDetails} from "./SellerShopifyDetails";
import SellerShopifySyncSettings from "./SellerShopifySyncSettings";

export const UpdateSellerForm = (props) => {
    const {VerticleTab,errors,register,sellerState,isPremium,setIsPremium,isTaxChargeable,setIsTaxChargeable,trigger,setValue,getValues,sellerSinceDate,setSellerSinceDate,setPhotoIndex,photoIndex, shopifyLocations, showShopifySyncSettingsTab, shopifyUkDetection, watch}=props;
    return (

        <TabContent activeTab={VerticleTab}>
            <TabPane className="fade show" tabId="1">
                <PrimaryDetails {...props} />
            </TabPane>
            <TabPane tabId="2">
                <BrandDetails {...props} />
            </TabPane>
            <TabPane tabId="3">
                <SellerStoreDescription {...props}/>
            </TabPane>
            <TabPane tabId="4">
                <ExtraInformation {...props} />
            </TabPane>
            <TabPane tabId="5">
                <HeadingLinks {...props}/>
            </TabPane>
            <TabPane tabId="6">
                <CustomerServiceContactDetails {...props}/>
            </TabPane>
            <TabPane tabId="7">
                <ReturnsWarehouseAddress {...props}/>
            </TabPane>
            <TabPane tabId="8">
                <SellerShopifyDetails {...props}/>
            </TabPane>
            <TabPane tabId="9">
                <UploadImage {...props}/>
            </TabPane>
            <TabPane tabId="10">
                <UploadBannerImage {...props}/>
            </TabPane>

            {/* Tab 11: Shopify Sync Settings (only after backend save enables integration) */}
            {showShopifySyncSettingsTab && (
                <TabPane tabId="11">
                    <SellerShopifySyncSettings
                        errors={errors}
                        register={register}
                        trigger={trigger}
                        setValue={setValue}
                        getValues={getValues}
                        watch={watch}
                        shopifyLocations={shopifyLocations}
                        ukCatalogs={shopifyUkDetection?.ukCatalogs || []}
                        gbpContextualAvailable={!!shopifyUkDetection?.gbpContextualAvailable}
                        gbpContextualError={shopifyUkDetection?.gbpContextualError || ""}
                    />
                </TabPane>
            )}
        </TabContent>
    );
};